import { Component, OnInit } from '@angular/core';
import { IWidgetEditor, WidgetType, ClockWidget } from "src/app/models/dashboard";
import { Dashboard, SiteType, Widget } from 'src/api/models'
import { SiteTypeService } from 'src/api/services';

@Component({
  selector: 'overdue-sites-widget-editor',
  templateUrl: './overdue-sites-widget-editor.component.html',
  styleUrls: ['./overdue-sites-widget-editor.component.css']
})
export class OverdueSitesWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: Widget;
  public dashboard: Dashboard;
  public siteTypes: SiteType[];

  constructor(public siteTypeService: SiteTypeService) {
  }

  ngOnInit() {
    this.widget.size = 3;
    this.siteTypeService.SiteTypeGetAll(this.dashboard.customerId).subscribe(siteTypes => {
      this.siteTypes = siteTypes;
    });
  }

}
